import MultiStepForm from '@/components/forms/MultiStepForm';
import TokenCopy from '@/components/forms/apps/pma/TokenCopy';
import USVConfig from '@/components/forms/apps/pma/USVConfig';
import HypervisorInterfacesConfig from '@/components/forms/apps/pma/HypervisorInterfacesConfig';
import DeploymentStatus from '@/components/forms/apps/pma/DeploymentStatus';
import tenant from '@/services/TenantService';
import { toast } from 'react-toastify';
import ToastMessage from '@/components/toasts/ToastMessage';
import { useState } from 'react';

export default function PMAInitialEdit({
  deployment,
  token,
  onFinish,
  onCancel,
}) {
  const [showDeploymentStatus, setShowDeploymentStatus] = useState(false);

  const handleSubmit = async (formData) => {
    try {
      const deploymentResp = await tenant.get(
        `/deployment/${deployment?.insertedId || deployment._id}`,
      );
      const deploymentObj = deploymentResp?.data;

      const initialSetupFinished = deploymentObj?.initialSetupFinished || false;

      // Only set the flags if this is the first time the setup is done
      const deploymentData = {
        config: {
          ...formData,
          ...(initialSetupFinished
            ? {
                isMaintenanceActive: deploymentObj.config.isMaintenanceActive,
                isSyncingAccepted: deploymentObj.config.isSyncingAccepted,
              }
            : {
                isMaintenanceActive: false,
                isSyncingAccepted: true,
              }),
          ...(deploymentObj?.config?.status && {
            status: deploymentObj.config.status,
          }),
        },
      };
      await tenant.put(`/deployment/${deploymentObj._id}`, deploymentData);
      setShowDeploymentStatus(true);
    } catch (error) {
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle={
            error?.response?.data?.message ||
            'Fehler beim Erstellen der Konfiguration'
          }
        />,
      );
    }
  };

  const handleFinishDeploymentSetup = async (deploymentId) => {
    const paymentRequired = false;
    try {
      await tenant.put(`/deployment/${deploymentId}`, {
        initialSetupFinished: true,
      });
    } catch (error) {
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle={
            error?.response?.data?.message ||
            'Fehler beim Aktualisieren der Bereitstellung'
          }
        />,
      );
    }

    onFinish(deploymentId, paymentRequired);
  };

  const steps = [
    <TokenCopy key="tokenCopy" deployment={deployment} token={token} />,
    <USVConfig key="usvConfig" deployment={deployment} />,
    <HypervisorInterfacesConfig key="vcenterConfig" deployment={deployment} />,
  ];

  return (
    <>
      {showDeploymentStatus ? (
        <DeploymentStatus
          deployment={deployment}
          handleFinishDeploymentSetup={handleFinishDeploymentSetup}
          resetToFirstStep={() => setShowDeploymentStatus(false)}
          handleCancel={onCancel}
        />
      ) : (
        <MultiStepForm
          steps={steps}
          onSubmit={handleSubmit}
          onCancel={onCancel}
        />
      )}
    </>
  );
}
